import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule
} from '@angular/forms';
import { EINVOICE_AP_TINTYPE } from '@core';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { ViewItemComponent } from 'src/app/shared/components/view-item/view-item.component';

@Component({
  selector: 'app-einvoice-ap-tintype-select',
  templateUrl: './einvoice-ap-tintype-select.component.html',
  styles: [],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ViewItemComponent,
    NzSelectModule
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EInvoiceApTinTypeSelectComponent),
      multi: true
    }
  ]
})
export class EInvoiceApTinTypeSelectComponent implements ControlValueAccessor {
  statusLabel: { [key: number]: string } = {};

  get options() {
    if (this.showCode) {
      return EINVOICE_AP_TINTYPE.sort((a, b) => a.value - b.value);
    }

    return EINVOICE_AP_TINTYPE;
  }

  @Input() value: number = 0;
  @Input() disabled = false;
  @Input() borderless = false;
  @Input() allowEdit = true;
  @Input() showCode = false;

  get readonly() {
    if (this.disabled) {
      return true;
    }
    return false;
  }

  get displayText() {
    const item = this.options.find(x => x.value === this.value);
    return this.getLabel(item);
  }

  getLabel(item: any) {
    if (item) {
      if (this.showCode) return `${item.value} - ${item.label}`;
      return item.label;
    }
    return '';
  }

  onChange: any = () => {};
  onTouched: any = () => {};
  constructor(private cdr: ChangeDetectorRef) {}

  writeValue(value: number): void {
    this.value = value;
    this.onChange(value);
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onModelChange(val: any) {
    this.value = val;
    this.onChange(val);
    this.cdr.markForCheck();
  }
}
